<div style="display: flex; justify-content: center;">
  <div class="fd-business-data-detail__card-container" *ngIf="data">
    <table mat-table [dataSource]="dataSource" class="fd-table">
      <ng-container matColumnDef="technology" class="fd-table__cell">
        <th mat-header-cell *matHeaderCellDef class="fd-table__header">Tecnologia</th>
        <td mat-cell *matCellDef="let rowElement">{{ rowElement.technology }}</td>
      </ng-container>

      <ng-container matColumnDef="price" class="fd-table__cell">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="fd-table__header">Valor Mensal</th>
        <td mat-cell *matCellDef="let rowElement">{{ rowElement.price | currency: 'BRL' }}</td>
      </ng-container>

      <tr mat-header-row class="fd-table__header-row" *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row class="fd-table__row" *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</div>
